import { PHONE, locationSchema } from "../structured-data-core";

export function getMiamiStructuredData() {
  const url = "https://restorehair.com/locations/florida/miami/";
  const description =
    "Find out about your hair transplant options in Miami with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Miami", "80 SW 8th St, Suite 2000", "Miami", "FL", PHONE, url, description),
  ];
}
